import { observer } from 'mobx-react-lite'
import { useState, type FC } from 'react'
import { Button } from 'shared/ui'
import { type AutoRechargeWidgetStore } from 'entities/Billing/ui/AutoRechargeModal'

type IAutoRechargeModalActionProps = {
  autoRechargeWidgetStore: AutoRechargeWidgetStore
}

export const AutoRechargeModalAction: FC<IAutoRechargeModalActionProps> = observer(
  ({ autoRechargeWidgetStore }) => {
    const [loading, setLoading] = useState(false)
    const { onEnableAutoRecharge, disabledAutoRecharge, isActive } = autoRechargeWidgetStore

    const handleClick = async () => {
      setLoading(true)
      await onEnableAutoRecharge()
      setLoading(false)
    }

    return (
      <Button
        disabled={disabledAutoRecharge}
        onClick={handleClick}
        text={isActive ? 'Save' : 'Activate'}
        loading={loading}
      />
    )
  }
)
